import polling from './polling';

export default polling;
